<template>
  <v-container class="white-wrapper" fluid>
    <div class="img-container">
      <!-- <div class="btn-wrapper">
        <v-btn
          text
          color="primary"
          @click="clickRefresh"
          class="font-weight-bold"
          :disabled="!show"
        >
          새로고침<v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div> -->
      <transition name="fade">
        <div v-show="show">
          <qrcode-stream @decode="onDecode" class="qr-code qr-reader-box" />
        </div>
      </transition>
      
      <div  style="width:70%; margin-top: 10px;" v-show="this.qrCodeData"   >
        <v-btn color="primary" @click="submit"  x-large block>                
            <div>결제하기</div>          
         </v-btn>  
      </div>


      
    </div>
    <div class="bottom-text">스캐너에 QR코드를 <a href="/#/pay">스캔</a>하세요.</div>

    <!-- <div>
        <v-btn
          class="font-weight-bold mb-4"
          color="primary"
          block
          x-large 
          :disabled="isLoading"
        >            
        </v-btn>
    </div> -->

  </v-container>  
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component' ; 
import VueBarcode from 'vue-barcode' ;
import { QrcodeStream } from 'vue-qrcode-reader' ;  // , QrcodeDropZone, QrcodeCapture 

export default {
  components: { VueQRCodeComponent, VueBarcode , QrcodeStream },
  data: () => ({
    nowTime: new Date().getTime(),
    timer: '',
    show: true,
    duration: 10000,
    selectedCoin: null,
    coinName: 'LSS' , 
    qrCodeData : null 
     
  }),
  computed: {
    isLoading() {
      alert(this.$store.getters.loading)
      return true ; // this.$store.getters.loading
    },    
    user() {
      return this.$store.getters.user
    },
    jsonData() {
      return JSON.stringify({
        uid: this.user.id,
        now: this.nowTime,
        token: this.coinName
      })
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      return this.$store.getters.wallet.filter(
        (i) => i.name !== 'USDT' //&& i.name !== 'ETH'
      )
    }
  },
  methods: { 
    submit (){
      if( this.qrCodeData ) {
        let _info = JSON.parse(this.qrCodeData  ) ;           
        // alert(_info.uid ) ; 
        // return false ;

        let params = { 
            proc: 'payment' , 
            uid: this.user.id,
            now: this.nowTime,
            token: "LSS" , // this.coinName , 
            payment_id: _info.payment_id
        } ; 

        this.$store.commit('loading', true)         
        
        if( _info.uid == 0  && _info.hasOwnProperty('ptype')  )  {

             
          params.barcode = this.qrCodeData  ; 
          params.product = _info.ptype ; 
          params.shop = _info.ptype ; 
          params.token = _info.token ;        
          params.orderCode = _info.payment_id ; 
          params.priceSum = _info.total ; 
 
          this.$store
          .dispatch('market_payed', params )
          .then((response) => {
            console.log( response )

            if ( response.data.status == true  ) {          

                //alert( response.data.msg  ) ;  
                alert('결제가 완료되었습니다.') ;
                location.reload() ; 
                return false ;  
            } else { 
                alert(response.data.msg || '결제정보를 다시 확인해 주세요 ') ; 
                location.reload() ; 
                return false ; 
            } ;  
          }) ; 


        }else{

          this.$store
          .dispatch('STAFF_ACT', params )
          .then((response) => {
            console.log( response )
            if ( response.data.status == true  ) {          

                alert( response.data.msg  ) ;  
                location.reload() ; 
                return false ;  
            } else { 
                alert(response.data.msg || '결제정보를 다시 확인해 주세요 ') ; 
                location.reload() ; 
                return false ; 
            } ;  
          }) ; 
        } ;





      }else{
        alert('다시 스캔해주세요.') ; 
        this.qrCodeData  = null ; 
      }
      return false ; 
    } , 
    onDecode (result) {
      this.qrCodeData = result
       console.log( this.qrCodeData  , result )  
    }  , 

    refresh() {
      this.nowTime = new Date().getTime()
      this.show = true
      this.coinName = this.selectedCoin.name
    },
    fadeRefresh() {
      this.show = false
      setTimeout(this.refresh, 500)
    },
    clickCoin(item) {
      this.selectedCoin = item
      this.fadeRefresh()
      clearInterval(this.timer)
      this.timer = setInterval(this.fadeRefresh, this.duration)
    }
  },
  created() {
    // this.$store.commit('loading', true)

    // this.timer = setInterval(this.fadeRefresh, this.duration)
    // this.selectedCoin = this.wallet.filter((i) => i.name === 'CCS')[0]
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  padding: 0 1rem;
  width: 100%;
}
.img-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 196px);
  overflow: auto;
  padding: 3rem 0 1rem;
}
.barcode {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0 0;
  max-width: 350px !important;
}
.bottom-text {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: #e9e9e9;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qr-reader-box {
  width: 250px !important;
  height: 250px !important;
  
  margin: auto;
}
</style>
